const message = {
  departments: "Departamentos",
  pathologiesMostConsulted: "Patologías más<br> consultadas",
  institution: "Institución",
  followUs: "Síguenos en las redes",
  allRightsReserved: "Todos los derechos reservados",
  aboutIncocegla: "Sobre Incocegla",
  glaucomaClub: "Club Glaucoma",
  incoceglaFoundation: "Fundación Incocegla",
};
export default message;
